import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';

/**
 * 차단 사용자 목록 조회
 *
 * Origin: pageNicolasApi.getBlockUserList
 * API: GET /api/v1/store/community/block/list
 */
export async function getStoreCommunityBlockList(
  options?: FetcherOptions
): Promise<ApiResultVo & {result: {list?: number[]}}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/store/community/block/list',
    {
      method: 'GET',
    },
    options
  );
  return response.data;
}
